module.exports = __webpack_public_path__ + "img/94039.ef7af2c1.svg";